import { NavLink, Outlet, useNavigate, Navigate, Link } from "react-router-dom";
import { LayoutDashboard, Users, ClipboardList, LogOut, Scan, Boxes, ShoppingCart, Package } from "lucide-react";
import { clearToken, getToken } from "../lib/api";

export default function AdminLayout() {
  const nav = useNavigate();
  const token = getToken();
  if (!token) return <Navigate to="/admin/login" replace />;

  const logout = () => {
    clearToken();
    nav("/admin/login", { replace: true });
  };

  const linkCls = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3 text-sm uppercase tracking-widest transition-colors ${
      isActive
        ? "text-[#0A0908] bg-[#C89B3C]"
        : "text-[#B8A99A] hover:text-[#C89B3C] hover:bg-white/5"
    }`;

  return (
    <div className="min-h-screen bg-[#0A0908] text-[#F5F0E6] flex">
      <aside
        data-testid="admin-sidebar"
        className="w-72 shrink-0 bg-[#12100E] border-r border-white/5 flex flex-col"
      >
        <div className="p-6 border-b border-white/5">
          <p className="text-[0.6rem] uppercase tracking-[0.5em] text-[#C89B3C] mb-1">
            Panel Admin
          </p>
          <p className="font-serif text-xl font-black leading-tight">
            EL NAVEGANTE
            <br />
            <span className="italic text-[#C89B3C]">Wester</span>
          </p>
        </div>

        <nav className="flex-1 py-4 space-y-1 overflow-y-auto">
          <NavLink to="/admin" end className={linkCls} data-testid="nav-dashboard">
            <LayoutDashboard size={18} /> Dashboard
          </NavLink>
          <Link
            to="/admin/scan"
            className="mx-3 my-2 flex items-center justify-center gap-2 bg-[#C89B3C] hover:bg-[#E6BF5F] text-[#0A0908] font-black uppercase tracking-wider text-sm py-3 rounded-lg shadow-lg shadow-[#C89B3C]/20"
            data-testid="nav-scan"
          >
            <Scan size={18} /> SCAN PRODUCT
          </Link>
          <NavLink to="/admin/inventory" className={linkCls} data-testid="nav-inventory">
            <Boxes size={18} /> Inventario
          </NavLink>
          <NavLink to="/admin/products" className={linkCls} data-testid="nav-products">
            <Package size={18} /> Productos
          </NavLink>
          <NavLink to="/admin/orders" className={linkCls} data-testid="nav-orders">
            <ShoppingCart size={18} /> Pedidos
          </NavLink>
          <NavLink to="/admin/customers" className={linkCls} data-testid="nav-customers">
            <Users size={18} /> Clientes
          </NavLink>
          <NavLink to="/admin/layaways" className={linkCls} data-testid="nav-layaways">
            <ClipboardList size={18} /> Apartados
          </NavLink>
        </nav>

        <div className="p-4 border-t border-white/5 space-y-2">
          <a
            href="/"
            data-testid="admin-view-site"
            className="block text-xs uppercase tracking-widest text-[#8A7D71] hover:text-[#C89B3C] transition-colors py-2 px-2"
          >
            ← Ver el sitio
          </a>
          <button
            onClick={logout}
            data-testid="admin-logout"
            className="w-full flex items-center gap-2 text-xs uppercase tracking-widest text-[#B8A99A] hover:text-red-300 transition-colors py-2 px-2"
          >
            <LogOut size={14} /> Cerrar sesión
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0 p-6 md:p-10 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
